var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "#2B55EF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.25V0H0.75C0.334375 0 0 0.334375 0 0.75V15.25C0 15.6656 0.334375 16 0.75 16H11.25C11.6656 16 12 15.6656 12 15.25V5H7.75C7.3375 5 7 4.6625 7 4.25ZM9.03687 11.0003H7V13.5003C7 13.7766 6.77625 14.0003 6.5 14.0003H5.5C5.22375 14.0003 5 13.7766 5 13.5003V11.0003H2.96312C2.51688 11.0003 2.29406 10.46 2.61094 10.1453L5.62406 7.15469C5.83187 6.94812 6.1675 6.94812 6.37531 7.15469L9.38844 10.1453C9.70562 10.46 9.48312 11.0003 9.03687 11.0003ZM11.7812 3.28125L8.72188 0.21875C8.58125 0.078125 8.39062 0 8.19063 0H8V4H12V3.80938C12 3.6125 11.9219 3.42188 11.7812 3.28125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.0b1f86624cc59decd65ba04a75ea4de3.svg";
export { ForwardRef as ReactComponent };